import { isDesktop } from 'react-device-detect';

var mult = isDesktop ? 1 : 2;

export const BonusItems = {
	name: 'splash_progressive_bonus_view_holder',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'bonus_item_1',
			type: 'Sprite',
			position: {
				x: 95,
				y: -105
			},
			components: [
				{
					name: 'bonus_item_progress',
					type: 'Sprite',
					img: 'bonus_progress_item_1',
					position: {
						x: 10,
						y: 10
					},
					scale: { x: 0.8 * mult, y: 0.8 * mult }
				},
				{
					name: 'bonus_item_special',
					type: 'Sprite',
					img: 'bonus_character',
					position: {
						x: 25,
						y: -65
					},
					scale: { x: 0.8 * mult, y: 0.8 * mult }
				}
			]
		},
		{
			name: 'bonus_item_2',
			type: 'Sprite',
			position: {
				x: 230,
				y: -140
			},
			components: [
				{
					name: 'bonus_item_progress',
					type: 'Sprite',
					img: 'bonus_progress_item_1',
					position: {
						x: 0,
						y: 14
					},
					scale: {
						x: 0.8 * mult,
						y: 0.8 * mult
					}
				},
				{
					name: 'bonus_item_special',
					type: 'AnimatedSprite',
					position: { x: 10, y: -50 },
					scale: { x: 0.35 * mult, y: 0.35 * mult },
					animation: {
						pattern: '01_CrystalStable$.png',
						start: 0,
						end: 71,
						speed: 0.5,
						precision: 2,
						loop: true
					}
				}
			]
		},
		{
			name: 'bonus_item_3',
			type: 'Sprite',
			position: {
				x: 360,
				y: -160
			},
			components: [
				{
					name: 'bonus_item_progress',
					type: 'Sprite',
					img: 'bonus_progress_item_2',
					position: {
						x: 0,
						y: 25
					},
					scale: {
						x: 0.75 * mult,
						y: 0.75 * mult
					}
				},
				{
					name: 'bonus_item_special',
					type: 'AnimatedSprite',
					position: { x: 28, y: -50 },
					scale: { x: 0.7 * mult, y: 0.7 * mult },
					animation: {
						pattern: '03_Heart$.png',
						start: 0,
						end: 71,
						speed: 0.5,
						precision: 2,
						loop: true
					}
				},
				{
					name: 'text',
					type: 'Text',
					text: 'BONUS_ITEM_3_TEXT',
					position: { x: 45, y: 23 }
				},
				{
					name: 'subtext',
					type: 'Text',
					text: 'BONUS_ITEM_3_SUBTEXT',
					position: { x: 40, y: 69 }
				}
			]
		},
		{
			name: 'bonus_item_4',
			type: 'Sprite',
			position: {
				x: 535,
				y: -100
			},
			components: [
				{
					name: 'bonus_item_progress',
					type: 'Sprite',
					img: 'bonus_progress_item_1',
					position: {
						x: 0,
						y: -5
					},
					scale: { x: 0.8 * mult, y: 0.8 * mult }
				},
				{
					name: 'bonus_item_special',
					type: 'AnimatedSprite',
					position: { x: 10, y: -68 },
					scale: { x: 0.35 * mult, y: 0.35 * mult },
					animation: {
						pattern: '01_CrystalStable$.png',
						start: 0,
						end: 71,
						speed: 0.5,
						precision: 2,
						loop: true
					}
				}
			]
		},
		{
			name: 'bonus_item_5',
			type: 'Sprite',
			position: {
				x: 675,
				y: -140
			},
			components: [
				{
					name: 'bonus_item_progress',
					type: 'Sprite',
					img: 'bonus_progress_item_1',
					position: {
						x: -5,
						y: 0
					},
					scale: {
						x: 0.8 * mult,
						y: 0.8 * mult
					}
				},
				{
					name: 'bonus_item_special',
					type: 'AnimatedSprite',
					position: { x: 5, y: -60 },
					scale: { x: 0.35 * mult, y: 0.35 * mult },
					animation: {
						pattern: '01_CrystalStable$.png',
						start: 0,
						end: 71,
						speed: 0.5,
						precision: 2,
						loop: true
					}
				}
			]
		},
		{
			name: 'bonus_item_6',
			type: 'Sprite',
			position: {
				x: 800,
				y: -160
			},
			components: [
				{
					name: 'bonus_item_progress',
					type: 'Sprite',
					img: 'bonus_progress_item_2',
					position: {
						x: 0,
						y: 30
					},
					scale: {
						x: 0.75 * mult,
						y: 0.75 * mult
					}
				},
				{
					name: 'bonus_item_special',
					type: 'AnimatedSprite',
					position: { x: 25, y: -55 },
					scale: { x: 0.7 * mult, y: 0.7 * mult },
					animation: {
						pattern: '04_Star$.png',
						start: 0,
						end: 71,
						speed: 0.5,
						precision: 2,
						loop: true
					}
				},
				{
					name: 'text',
					type: 'Text',
					text: 'BONUS_ITEM_6_TEXT',
					position: { x: 25, y: 30 }
				},
				{
					name: 'subtext',
					type: 'Text',
					text: 'BONUS_ITEM_6_SUBTEXT',
					position: { x: 30, y: 75 }
				}
			]
		}
	]
};
